import React from "react";
import { List as AntdMobileList } from "antd-mobile";
import { BaseListProps, BaseListItemData } from "./List.types";
import { ListItem } from "./ListItem";
import "./List.scss";

const BaseList: React.FC<BaseListProps> = ({
  // antd-mobile List 属性
  header,
  mode = "default",
  // 自定义属性
  items,
  children,
  variant = "primary",
  size = "md",
  bordered = true,
  className = "",
  testId,
  ...props
}) => {
  const listClass = [
    "list",
    `list--${variant}`,
    `list--${size}`,
    `list--${mode}`,
    bordered && "list--bordered",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  // 渲染列表项
  const renderItems = () => {
    if (items && items.length > 0) {
      return items.map((item: BaseListItemData) => (
        <ListItem
          key={item.key}
          title={item.title}
          description={item.description}
          extra={item.extra}
          prefix={item.prefix}
          arrowIcon={item.arrowIcon}
          clickable={item.clickable}
          onClick={item.onClick}
          disabled={item.disabled}
          variant={item.variant || variant}
          size={item.size || size}
          className={item.className}
        />
      ));
    }
    return children;
  };

  return (
    <AntdMobileList
      className={listClass}
      data-testid={testId}
      header={header}
      mode={mode}
      {...props}
    >
      {renderItems()}
    </AntdMobileList>
  );
};

// 创建带静态属性的 List 组件
const ListWithItem = BaseList as typeof BaseList & {
  Item: typeof ListItem;
};

ListWithItem.Item = ListItem;

export { ListWithItem as List };

export default ListWithItem;
